<ng-container *ngIf="loading; else warningView">
	<atomic-loading-icon class="h-[250px]"></atomic-loading-icon>
</ng-container>
<ng-template #warningView>
	<div class="flex flex-col w-[1000px] h-[648px]">
		<div class="border-b">
			<h1 class="modal-header">Create Closer Matter</h1>
		</div>
		<div id="frame-626704" class="flex flex-col gap-6 self-stretch">
			<div id="frame-627568" class="flex self-stretch">
				<div
					id="content"
					class="flex flex-col justify-center bg-gray-50 w-[486px] h-[572px] pt-0 pb-0 pr-6 pl-6"
				>
					<img
						class="w-auto"
						src="/assets/images/leap/person-envelope.png"
						alt="Person holding envelope"
					/>
				</div>
				<div id="frame-627569" class="flex flex-col flex-1">
					<div
						id="content"
						class="flex flex-col gap-6 self-stretch p-6 h-[496px]"
					>
						<div id="frame-1010108785" class="flex flex-col gap-6 self-stretch">
							<div class="text-sm">
								This matter has been set as a "Conveyancing - Closer" matter
								type in LEAP. Would you like to import this matter into Closer?
							</div>
							<div class="text-sm">
								The following pricing structure will apply:
							</div>
							<div class="flex flex-col gap-4 self-stretch">
								<h4>Matter Pricing</h4>
								<div class="flex gap-4">
									<div
										class="h-28 p-4 border bg-orange-lightest border-orange-light text-orange-dark; rounded-md font-semibold text-base flex flex-col flex-1 flex-shrink-0 text-center justify-center align-middle gap-4"
									>
										<div>
											{{ salePrice | centsToDollars }}
										</div>
										<div class="mt">Sale file</div>
									</div>
									<div
										class="h-28 p-4 border bg-purple-lighter border-purple-light text-purple-darker rounded-md font-semibold text-base flex flex-col flex-1 flex-shrink-0 text-center justify-center align-middle gap-4"
									>
										<div>
											{{ refinancePrice | centsToDollars }}
										</div>
										<div>Refinance file</div>
									</div>
									<div
										class="h-28 p-4 border bg-blue-lightest border-blue-light text-blue-dark rounded-md font-semibold text-base flex flex-col flex-1 flex-shrink-0 text-center justify-center align-middle gap-4"
									>
										<div>
											{{ purchasePrice | centsToDollars }}
										</div>
										<div>Purchase file</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div id="content-footer-2" class="flex justify-end gap-4 mt-8">
						<ui-button
							preset="LOW_EMPHASIS"
							label="Not Now"
							(click)="closeDialog(answer.No)"
						></ui-button>
						<ui-button
							preset="HIGH_EMPHASIS"
							label="Create Matter"
							(click)="closeDialog(answer.Yes)"
						></ui-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-template>
